var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcMoreVert = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "16px",
    viewBox: "0 0 4 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "kavabangaa16")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "kavabangaa2",
    x: 0,
    y: 0,
    width: 1170,
    height: 382,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-2.0%",
    width: "102.0%",
    height: "106.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "kavabangaa3",
    x: 0,
    y: 0,
    width: 1170,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,7.33333333 C12.0083333,7.33333333 12.8333333,6.50833333 12.8333333,5.5 C12.8333333,4.49166667 12.0083333,3.66666667 11,3.66666667 C9.99166667,3.66666667 9.16666667,4.49166667 9.16666667,5.5 C9.16666667,6.50833333 9.99166667,7.33333333 11,7.33333333 L11,7.33333333 Z M11,9.16666667 C9.99166667,9.16666667 9.16666667,9.99166667 9.16666667,11 C9.16666667,12.0083333 9.99166667,12.8333333 11,12.8333333 C12.0083333,12.8333333 12.8333333,12.0083333 12.8333333,11 C12.8333333,9.99166667 12.0083333,9.16666667 11,9.16666667 L11,9.16666667 Z M11,14.6666667 C9.99166667,14.6666667 9.16666667,15.4916667 9.16666667,16.5 C9.16666667,17.5083333 9.99166667,18.3333333 11,18.3333333 C12.0083333,18.3333333 12.8333333,17.5083333 12.8333333,16.5 C12.8333333,15.4916667 12.0083333,14.6666667 11,14.6666667 L11,14.6666667 Z",
    id: "kavabangaa4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "kavabangaa12",
    x: 0,
    y: 0,
    width: 45.8333333,
    height: 45.8333333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kavabangaa11",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kavabangaa15",
    transform: "translate(-1387.000000, -324.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "kavabangaa17",
    transform: "translate(250.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kavabangaa6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kavabangaa2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kavabangaa45"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "blue",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#kavabangaa2"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#DFE2E5",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#kavabangaa2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kavabangaa9",
    mask: "url(#kavabangaa6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kavabangaa7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kavabangaa3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "kavabangaa45",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#kavabangaa3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kavabangaa13",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#kavabangaa7)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1128.000000, 23.000000)",
    id: "kavabangaa16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kavabangaa8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kavabangaa4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kavabangaa45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kavabangaa13",
    mask: "url(#kavabangaa8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.916667, -11.916667)",
    id: "kavabangaa"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kavabangaa14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kavabangaa12"
  })), /*#__PURE__*/React.createElement("use", {
    id: "kavabangaa10",
    fill: "#000000",
    xlinkHref: "#kavabangaa12"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcMoreVert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-more-vert.9802b081.svg";
export { ForwardRef as ReactComponent };